import { Component } from '@theme/component';
/** A single published review, rotated only while visible and not being read. */
class WbHeroReview extends Component {
  async connectedCallback() {
    super.connectedCallback();
    this.abort = new AbortController();
    this.index = 0;
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.paused = this.motion.matches;
    this.motion.addEventListener('change', () => { this.paused = this.motion.matches; this.updatePause(); }, { signal: this.abort.signal });
    try {
      const response = await fetch(this.dataset.source, { signal: this.abort.signal });
      if (!response.ok) return;
      const all = (await response.json()).filter(r => r.quote && r.author && r.product && r.rating >= 1 && r.rating <= 5);
      const normalize = title => title.toLowerCase().replace(/^(men[’']s|women[’']s)\s+/, '').trim();
      const matching = all.filter(r => normalize(r.product) === normalize(this.dataset.product));
      const ratingLabel = this.closest('.wb-product-hero')?.querySelector('[data-store-rating]');
      if (ratingLabel && all.length) {
        const average = all.reduce((sum, r) => sum + r.rating, 0) / all.length;
        ratingLabel.textContent = `${average.toFixed(1)} / 5 · ${all.length} ${ratingLabel.dataset.storeRating}`;
      }
      this.reviews = matching.length ? matching : all;
      if (!this.reviews.length) return;
      this.hidden = false;
      this.render();
      this.updatePause();
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; });
      this.observer.observe(this);
      this.timer = setInterval(() => {
        if (!this.paused && this.visible && !document.hidden && !this.matches(':hover') && !this.contains(document.activeElement)) this.move(1);
      }, 8000);
    } catch (error) { if (error.name !== 'AbortError') this.hidden = true; }
  }
  previous() { this.move(-1); }
  next() { this.move(1); }
  move(step) { this.index = (this.index + step + this.reviews.length) % this.reviews.length; this.render(); }
  toggle() { this.paused = !this.paused; this.updatePause(); }
  updatePause() {
    this.refs.pause.textContent = this.paused ? '▶' : 'Ⅱ';
    this.refs.pause.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
  }
  render() {
    const review = this.reviews[this.index];
    this.refs.quote.textContent = review.quote;
    this.refs.author.textContent = review.author;
    this.refs.product.textContent = review.product;
    this.refs.stars.textContent = '★'.repeat(review.rating) + '☆'.repeat(5 - review.rating);
    this.refs.stars.setAttribute('aria-label', `${review.rating} / 5`);
    this.refs.counter.textContent = `${this.index + 1} / ${this.reviews.length}`;
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.abort?.abort();
    this.observer?.disconnect();
    clearInterval(this.timer);
  }
}
if (!customElements.get('wb-hero-review')) customElements.define('wb-hero-review', WbHeroReview);
